import {
  calculateJWTTokenExpirationDate,
  calculateOauthTokenExpirationDate,
  createAuthMiddleware,
  createAuthReducer,
} from '@tshio/redux-api-auth-middleware';
import contentMiddleware from '@tshio/redux-api-content-middleware';
import createEndpointMiddleware from '@tshio/redux-api-endpoint-middleware';
import paramsMiddleware from '@tshio/redux-api-params-middleware';
import cookies from 'js-cookie';
import { applyMiddleware, combineReducers, compose, createStore as reduxCreateStore } from 'redux';
import { apiMiddleware } from 'redux-api-middleware';
import { devToolsEnhancer } from 'redux-devtools-extension/logOnlyInProduction';
import { getEnvironmentVar } from 'utils';

import { refreshToken as refreshTokenAction } from './api/authorization/authorizationActions';
import { refreshTokenMiddleware } from './api/middlewares/refreshTokenMiddleware';

export const AUTH_COOKIE = 'auth_token';
export const AUTH_REFRESH_COOKIE = 'auth_refresh_token';
export const REFRESH_TOKEN_ERROR = 'REFRESH_TOKEN_ERROR';

const endpointMiddleware = createEndpointMiddleware({
  apis: {
    default: {
      apiUrl: getEnvironmentVar('REACT_APP_PORTAL_DEV_API_URL'),
      credentials: 'omit',
    },
  },
});

const authMiddleware = createAuthMiddleware({
  authConfig: {
    header: 'Authorization',
    type: 'Bearer',
  },
  refreshConfig: {
    actionDefinition: ({ refreshToken }) => refreshTokenAction(refreshToken),
    endpoint: 'ouath/token',
    failedAction: { type: REFRESH_TOKEN_ERROR },
  },
});

const middlewares = [
  endpointMiddleware,
  contentMiddleware,
  paramsMiddleware,
  authMiddleware,
  apiMiddleware,
  refreshTokenMiddleware,
];

const authReducer = createAuthReducer({
  getExpirationTimestamp: response => calculateOauthTokenExpirationDate(response) - 100,
});

export const createStore = () =>
  reduxCreateStore(
    combineReducers({
      auth: authReducer,
    }),
    {
      auth: {
        accessToken: cookies.get(AUTH_COOKIE) || '',
        expires: cookies.get(AUTH_COOKIE)
          ? calculateJWTTokenExpirationDate({
              access_token: cookies.get(AUTH_COOKIE),
            }) - 100
          : 0,
        refreshToken: cookies.get(AUTH_REFRESH_COOKIE) || '',
      },
    },
    compose(
      applyMiddleware(...middlewares),
      devToolsEnhancer({ name: 'Primary' }),
    ),
  );
